<template>
  <div class="jps-curation-list-image-view">
    <div class="jps-image-view-element" v-for="item in items" :key="item.key">
      <UiButtonIcon
        tag="button"
        v-if="editable"
        class="jps-icon-button list-delete"
        @click.stop="emits('delete-item', item)"
        icon="mdi/close-circle"
      />
      <template v-if="!item.readNext">
        <BaseLink
          class="jps-image-view-image"
          v-bind="baseLinkProps(item)"
          @click="emits('show-modal', item)"
          :show-icon="false"
        >
          <UiImageSelection
            :image="item.image"
            image-usage="thumbnail"
          />
          <ListEditIcon :item="item" field="image" :editstate="editstate" />
        </BaseLink>
        <div class="jps-image-view-element-desc">
          <div
            class="jci-caption is-size-6-desktop is-size-7-touch has-text-weight-bold"
          >
            <BaseLink
              v-bind="baseLinkProps(item)"
              @click="emits('show-modal', item)"
            >
              {{ ls(item.title) }}
            </BaseLink>
            <ListEditIcon :item="item" field="title" :editstate="editstate" />
            <ListEditIcon :item="item" field="url" :editstate="editstate" />
            <ListEditIcon :item="item" field="linkUrl" :editstate="editstate" />
          </div>
          <div class="jci-description-text is-size-6-desktop is-size-7-touch">
            {{ ls(item.description) }}
            <ListEditIcon :item="item" field="description" :editstate="editstate" />
          </div>
          <UiInteractPanel
            v-if="item.data"
            :type="item.type"
            :data="item.data"
            :image="item.image"
            class="jps-card-icon"
          />
        </div>
      </template>
      <SearchResultDiv v-else :item="item" :editstate="editstate" />
    </div>
    <div class="list-add-div" v-if="editable && !isNote">
      <button
        class="jps-icon-button list-add-button jps-sub-orange"
        @click="emits('add')"
      >
        <BaseIcon name="mdi/plus-circle" :alt="ls(addPartMsg)" size="size-4" />
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const { ls } = useI18n()

interface Props {
  editstate?: CurationEditState
  def : PartList
  items: ListElement[]
}
const props = withDefaults(defineProps<Props>(), {})

const emits = defineEmits(['delete-item', 'show-modal', 'add'])

const {
  isNote,
  hasExternalLink,
  baseLinkProps,
  editable,
  addPartMsg,
} = useCurationListView(props.editstate, props.def)
</script>

<style lang="scss" scoped>
@use '@/assets/styles/scss/vue' as *;

.jps-curation-list-image-view {
  .jps-image-view-element {
    display: flex;
    margin-top: 1rem;
    position: relative;
    .list-delete {
      position: absolute;
      top: 2px;
      right: 2px;
      background: $jps-gray-50;
    }
    @include is-mobile() {
      flex-direction: column;
      margin: 1rem 0;
    }
    .jps-image-view-image {
      height: 200px;
      position: relative;
      cursor: pointer;
      display: flex;
      align-items: center;
      @include is-mobile {
        width: 100%;
      }
      @include is-tablet {
        width: 50%;
      }
    }
    .jps-image-view-element-desc {
      @include is-mobile {
        width: 100%;
        padding: 0.5rem 1rem;
      }
      @include is-tablet {
        width: 50%;
        padding-left: 1rem;
      }
      .jci-caption {
        @include typo-list();
      }
      .jci-description-text {
        @include typo-figcaption();
        color: $jps-gray-600;
        margin-top: 0.5rem;
      }
      .jps-interact-panel {
        text-align: right;
        margin-right: 1rem;
      }
    }
    .jps-show-more {
    }
  }
  .jps-image-view-button-line {
    display: flex;
    justify-content: center;
  }
  .list-add-div {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem;
  }
}
</style>
